import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

function isPrivateVar(block: Blockly.Block): boolean {
    const myVarName = (block.getField('VAR_LABEL') as FieldVariableLabel | null)?.getValue();
    if (!myVarName) return false;

    let current = block.getSurroundParent();
    while (current) {
        // for_var内のカウンター変数
        if (current.type === 'for_var') {
            const counterName = (current.getField('VAR_LABEL') as FieldVariableLabel | null)?.getValue();
            if (counterName && counterName === myVarName) return true;
        }
        // func内の引数変数
        if (current.type === 'func') {
            const params: { id: string; type: string }[] = (current as any)._params ?? [];
            for (let i = 0; i < params.length; i++) {
                const paramField = current.getField(`PARAM_${params[i].id}`) as FieldVariableLabel | null;
                if (paramField?.getValue() === myVarName) return true;
            }
        }
        current = current.getSurroundParent();
    }
    return false;
}

defineBlock({
    type: 'var_get_number',
    colour: CATEGORIES.variable.color,
    tooltip: '数値変数の値を取得します',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('変数', { fontSize: 12, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () =>
                        new FieldVariableLabel('i', { fontWeight: 'normal', varType: 'float', showSymbol: false }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('', { minWidth: 0.1 }),
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        // ワークスペースへの配置後にfor_var内かチェックしてisPrivateを反映
        const applyPrivate = () => {
            const field = this.getField('VAR_LABEL') as FieldVariableLabel | null;
            if (!field) return;
            const inside = isPrivateVar(this);
            field.setIsPrivate(inside);
        };

        // 初回（2フレーム待ってSurroundParentが確定してから）
        requestAnimationFrame(() => requestAnimationFrame(applyPrivate));

        // 移動時・変数名変更時にも再チェック
        this.workspace.addChangeListener((e: Blockly.Events.Abstract) => {
            if (e.type === Blockly.Events.BLOCK_MOVE && (e as Blockly.Events.BlockMove).blockId === this.id) {
                requestAnimationFrame(applyPrivate);
                return;
            }
            if (e.type === Blockly.Events.BLOCK_CHANGE) {
                const ce = e as Blockly.Events.BlockChange;
                if (ce.element === 'field' && ce.name === 'VAR_LABEL') {
                    requestAnimationFrame(applyPrivate);
                }
                if (ce.element === 'field' && ce.name?.startsWith('PARAM_')) {
                    requestAnimationFrame(applyPrivate);
                }
            }
        });
    },
});
